import { createSlice } from "@reduxjs/toolkit";
import { answers, experts } from "../data";
import { getRandomInt } from "../../../util"

const oracularMessage = (text) => {
  return { text: text, sender: "oracular" };
};

const userMessage = (text) => {
  return { text: text, sender: "user" };
};

const initialState = {
  messages: [oracularMessage(answers[0])],
  oracular: experts[getRandomInt(0, experts.length - 1)],
  waitingResponse: false,
  isOracularTyping: false,
};

const persistedState = localStorage.getItem("reduxState")
  ? JSON.parse(localStorage.getItem("reduxState"))
  : initialState;

export const stateSlice = createSlice({
  name: "messenger",
  initialState: persistedState,
  reducers: {
    addMessage: (state, action) => {
      state.messages = [...state.messages, userMessage(action.payload)];
    },
    addResponse: (state, action) => {
      state.messages = [...state.messages, oracularMessage(action.payload)];
    },
    setWaitingResponse: (state, action) => {
      state.waitingResponse = true;
    },
    clearWaitingResponse: (state, action) => {
      state.waitingResponse = false;
    },
    setOraculIsTyping: (state, action) => {
      state.isOracularTyping = true;
    },
    clearOraculIsTyping: (state, action) => {
      state.isOracularTyping = false;
    },
  },
});

export const {
  addMessage,
  addResponse,
  setWaitingResponse,
  clearWaitingResponse,
  setOraculIsTyping,
  clearOraculIsTyping,
} = stateSlice.actions;

export default stateSlice.reducer;
